import { render, staticRenderFns } from "./logo-image.vue?vue&type=template&id=9f591538&scoped=true&"
import script from "./logo-image.vue?vue&type=script&lang=js&"
export * from "./logo-image.vue?vue&type=script&lang=js&"
import style0 from "./logo-image.vue?vue&type=style&index=0&id=9f591538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f591538",
  null
  
)

export default component.exports